/** Pure helpers for Budget Engine */

export function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function generateBudgetNumber(now = new Date()): string {
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  const seq = String(Math.floor(Math.random() * 9000) + 1000)
  return `ORC-${y}${m}${d}-${seq}`
}

export function createId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `bud_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
}

export function deepClone<T>(value: T): T {
  return structuredClone(value)
}
